import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const CallToAction = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1629450059521-746b6cf168a2"
          alt="HVAC Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/90 to-sky-blue/90"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Badge */}
          <div className="inline-block">
            <span className="bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold">
              24/7 Service Available
            </span>
          </div>

          {/* Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
            Need AC Installation or Service?
          </h2>

          {/* Description */}
          <p className="text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            Get in touch with our expert team today for a free consultation.
            We're here to help you stay cool and comfortable all year round.
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4 justify-center pt-4">
            <Button
              asChild
              size="lg"
              className="bg-white text-primary hover:bg-gray-100 px-8 py-6 text-lg shadow-xl hover:shadow-2xl transition-all"
            >
              <a href="tel:+919507331675">
                <Phone className="mr-2" size={20} />
                Call Now: +91 9507331675
              </a>
            </Button>
            <Button
              onClick={scrollToContact}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-6 text-lg transition-all"
            >
              Book Service
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </div>

          {/* Contact info */}
          <div className="flex flex-wrap gap-8 justify-center pt-8 border-t border-white/30">
            <a
              href="tel:+919507331675"
              className="flex items-center gap-2 text-white hover:text-white/80 transition-colors"
            >
              <Phone size={20} />
              <span className="font-semibold">+91 9507331675</span>
            </a>
            <a
              href="mailto:info@coolantairsystems.com"
              className="text-white hover:text-white/80 transition-colors"
            >
              <span className="font-semibold">info@coolantairsystems.com</span>
            </a>
            <a
              href="https://coolantairsystems.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-white/80 transition-colors"
            >
              <span className="font-semibold">coolantairsystems.com</span>
            </a>
          </div>

          {/* Trust indicators */}
          <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto pt-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">10+</div>
              <div className="text-sm text-white/80">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">500+</div>
              <div className="text-sm text-white/80">Happy Clients</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">98%</div>
              <div className="text-sm text-white/80">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
